export const ROUTE_MIDDLEWARE_ROLE = "ROUTE_MIDDLEWARE_ROLE"
export const ROUTE_MIDDLEWARE_SUBSCRIPTION = "ROUTE_MIDDLEWARE_SUBSCRIPTION"
export const ROUTE_MIDDLEWARE_USER_SETTINGS = "ROUTE_MIDDLEWARE_USER_SETTINGS"
export const ROUTE_MIDDLEWARE_COMPANY_DEACTIVATED =
  "ROUTE_MIDDLEWARE_COMPANY_DEACTIVATED"
